module.exports = __webpack_public_path__ + "static/media/NT_NhatNguyen.6f223366.jpg";